import { History } from "lucide-react";
import HomeProductRail from "@/components/HomeProductRail";
import { useRecentlyViewed } from "@/hooks/useRecentlyViewed";

/**
 * Session-scoped "Recently Viewed" rail for the home page.
 * Renders nothing on first visit — only appears once the user has
 * opened at least one product detail.
 */
export default function RecentlyViewedRail() {
  const { recent } = useRecentlyViewed();
  if (!recent || recent.length === 0) return null;
  return (
    <HomeProductRail
      title="Recently Viewed"
      icon={History}
      iconClass="text-amethyst-600"
      products={recent}
      viewAllHref="/marketplace"
      testId="rail-recent"
    />
  );
}
